import React from 'react';
import { PARTNER_COLORS } from '../constants';

export const PartnerFeatureCard = ({ icon: Icon, title, description }) => (
  <div className="bg-white rounded-2xl border border-[#E5E7EB] p-8 shadow-sm hover:shadow-md transition-shadow h-full">
    {Icon && (
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
        style={{ backgroundColor: `${PARTNER_COLORS.accent}18` }}
      >
        <Icon className="h-6 w-6" style={{ color: PARTNER_COLORS.accent }} />
      </div>
    )}
    <h3 className="text-lg font-bold mb-3" style={{ color: PARTNER_COLORS.navy }}>
      {title}
    </h3>
    <p className="text-[15px] leading-relaxed" style={{ color: PARTNER_COLORS.textMuted }}>
      {description}
    </p>
  </div>
);
